import { Backdrop, CircularProgress, Container } from "@mui/material";
import { ReactNode } from "react";

const ContainerLoading = ({
  loading = false,
  children,
  sx,
  maxWidth = false,
}: {
  loading?: boolean;
  children: ReactNode;
  sx?: any;
  maxWidth?: any;
}) => (
  <Container component="main" maxWidth={maxWidth} sx={(styles.container, sx)}>
    <Backdrop
      sx={{
        color: "primary.contrastText",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
    {children}
  </Container>
);

const styles = {
  container: {
    padding: { xs: 0 },
  },
};

export default ContainerLoading;
